import { ROUTES } from "@src/common/constants";
import { saveReferralCode } from "@src/utils/referral-tracker";
import { redirect } from "react-router-dom";

/**
 * Loader for invite route that extracts the referral code from the URL path
 * and redirects to the whiteboards page with the code as a query parameter
 */
export async function inviteRedirectLoader({
	params,
}: { params: { code?: string } }) {
	const code = params.code;

	if (!code) {
		// No code provided, redirect to whiteboards without ref parameter
		return redirect(ROUTES.whiteboards);
	}

	// Save the referral code to localStorage for the auth flow
	saveReferralCode(code);

	// Redirect to whiteboards with the ref query parameter
	return redirect(`${ROUTES.whiteboards}?ref=${encodeURIComponent(code)}`);
}
